<template>
    <v-card>
        <v-toolbar
            class="text-h6 mb-3"
            :class="darkMode ? '' : 'mt-1'"
        >
            Total
        </v-toolbar>
        <transition name="scroll-x-transition" mode="out-in">
            <div
                class="pt-3"
                v-if="!promiseToPay && checkSelectedPaymentStatus"
                key="payment-plan-subtotal"
            >
                <v-layout
                    class="px-3 pb-2"
                >
                    <v-flex xs6 data-testid="unit-name">Unit {{ selectedPaymentPlan.unit_name }}:</v-flex>
                    <v-flex
                        xs3
                        class="text-sm-right"
                        data-testid="unit-subtotal"
                    >${{ parseFloat(paymentTotalDue).toFixed(2) }}</v-flex>
                </v-layout>
                <v-divider class="mx-1 my-3" />
                <v-layout class="subheading font-weight-bold pb-3 px-3">
                    <v-flex xs6>Non-refundable Total Charges:</v-flex>
                    <v-flex
                        xs3
                        class="text-sm-right"
                        data-testid="payment-cart-total"
                    >${{ parseFloat(paymentTotalDue).toFixed(2) }}</v-flex>
                </v-layout>
            </div>
            <div
                class="pt-3"
                v-else-if="promiseToPay && checkSelectedPromiseStatus"
                key="promise-to-pay-subtotal"
            >
                <v-layout
                    class="px-3 pb-2"
                >
                    <v-flex xs6 data-testid="unit-name">Unit {{ selectedPromiseToPay.unit_name }}:</v-flex>
                    <v-flex
                        xs3
                        class="text-sm-right"
                        data-testid="promise-unit-subtotal"
                    >${{ parseFloat(promiseTotalDue).toFixed(2) }}</v-flex>
                </v-layout>
                <v-divider class="mx-1 my-3" />
                <v-layout class="subheading font-weight-bold pb-3 px-3">
                    <v-flex xs6>Non-refundable Total Charges:</v-flex>
                    <v-flex
                        xs3
                        class="text-sm-right"
                        data-testid="promise-cart-total"
                    >${{ parseFloat(promiseTotalDue).toFixed(2) }}</v-flex>
                </v-layout>
            </div>
            <div
                class="px-3 pt-3 pb-4 subheading"
                v-else
                key="no-cart-advisory"
                data-testid="no-cart-advisory"
            >
                Please select a plan...
            </div>
        </transition>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "PlanSideTotal",
  computed: {
    ...mapState({
      planCart: state => state.accountsReceivable.planCart,
      planMonthsChoice: state => state.accountsReceivable.planMonths,
      promiseCart: state => state.accountsReceivable.promiseCart,
      darkMode: state => state.application.settings.darkTheme
    }),

    ...mapGetters({
      selectedPromiseToPay: "selectedPromiseToPay",
      selectedPaymentPlan: "selectedPaymentPlan"
    }),

    promiseToPay() {
      return this.$route.name === "promiseToPay";
    },

    planMonths: {
      get() {
        return this.planMonthsChoice;
      },
      set(newVal) {
        this.$store.commit("setPlanMonths", newVal);
      }
    },

    paymentTotalDue() {
      if (this.selectedPaymentPlan.total_due === undefined) {
        return 0;
      } else {
        return this.selectedPaymentPlan.total_due;
      }
    },

    promiseTotalDue() {
      if (!this.selectedPromiseToPay) {
        return 0;
      } else {
        return this.selectedPromiseToPay.total_due;
      }
    },

    checkSelectedPaymentStatus() {
      if (this.selectedPaymentPlan && this.selectedPaymentPlan.ledger_id) {
        return true;
      }
      return false;
    },

    checkSelectedPromiseStatus() {
      return this.selectedPromiseToPay !== undefined;
    }
  }
};
</script>
